<template>
	<div class="news-list">
		<div class="ub ub-pj ub-ac" v-for="(post, i) in item.topPost" :key="i">
			<div class="article-title" v-if="(!showMore && i == 0) || showMore">
				<span>置顶</span>
				<h3><a @click="toDetail(post)">{{post.postName}}</a></h3>
			</div>
			<span v-if="i == 0 && !showMore" class="el-icon-caret-bottom color-98" @click="showMoreData"></span>
			<span v-if="i == item.topPost.length-1 && showMore" class="el-icon-caret-top color-98" @click="closeMoreData"></span>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'circleNews',
		components: {

		},
    props: {
      item: {
        type: Object,
        value: {}
      }
    },
		data(){
			return {
				showMore: false
			}
		},
		methods: {
      toDetail(item){
        this.$router.push({
					path: '/detail?id='+item.id+'&type=' + item.categoryScene
        })
      },
			showMoreData (){
				this.showMore = true
			},
			closeMoreData(){
				this.showMore = false
			}
		}
	}
</script>

<style scoped lang="less">
	.news-list{
		background: #fff;
		border-radius: 10px;
		margin-bottom: 10px;
		padding: 2px 0 15px;
	}
	.article-title{
		display: flex;
		align-items: center;
		margin-top: 10px;
		cursor: pointer;
		span{
			display: flex;
			justify-content: center;
			align-items: center;
			min-width: 32px;
			height: 18px;
			margin-right: 6px;
			background: rgba(207,23,29,.14);
			border-radius: 4px;
			font-size: 12px;
			color: #DD0515;
		}
		h3{
			font-weight: 400;
		}
	}
</style>
